import Record from '../Record'

export default class OpeningHours_Regular extends Record {

	constructor (data) {
		super(data)
		return this._proxy
	}

	validation_schema = {
		open: [
			[(value, params, data) => !(data.closed == 0 && !value), {}, 'Kötelező megadni']
		],
		close: [
			[(value, params, data) => !(data.closed == 0 && !value), {}, 'Kötelező megadni']
		],
		web_open: [
			[(value, params, data) => !(data.web_closed == 0 && !value), {}, 'Kötelező megadni']
		],
		web_close: [
			[(value, params, data) => !(data.web_closed == 0 && !value), {}, 'Kötelező megadni']
		],
	}
}
